import { Controller } from "stimulus"
import 'bootstrap-autocomplete'
import addresser from 'addresser'
import $ from 'jquery'
import 'bootstrap'
import getCountryISO3 from "country-iso-2-to-3"
import {
  shouldSkipLeadCaptureModal,
  mergeLeadCaptureCopy,
  applyLeadCaptureCopyToModal,
  applyStoredLeadCaptureAnswersToForm,
  bindStoredLeadCaptureToForm,
  prefillLeadCaptureModalFromSession,
  leadCaptureDismissable,
  validateAndCollectHowHeard,
  saveLeadCaptureAnswers
} from "./lead_capture_modal_utils"


export default class extends Controller {
  static targets = [
    "addressInput",
    "dbAddressCard",
    "addressCard",
    "addressCardTitle",
    "addressCountryInput",
    "addressIdInput",
    "addressStatusInput",
    "addressGeocodeServiceIdInput",
    "emailInput",
    "emailError",
    "streetError",
    "modalAvailblePrompt",
    "modalOutOfAreaPrompt",
    "modalNotServicablePrompt",
    "modalCancel"
  ]

  connect() {  
    window.statusAddressSearchController = this

    this.searchAddress = '';
    this.autocompleteSuggestions = [];

    this.hasLeadModalMarkup = this.data.get("hasLeadModalMarkup") === "true"
    this.currentStep = this.data.get("currentStep") || "service_address"
    try {
      this.leadCaptureConfig = JSON.parse(this.data.get("leadCaptureConfig") || "{}")
    } catch (_e) {
      this.leadCaptureConfig = {}
    }

    this.initializeBootstrapAutocomplete();
    bindStoredLeadCaptureToForm(this.element)
  }

  async initializeGoogleAutocomplete() {
    const { AutocompleteSuggestion, AutocompleteSessionToken } = await google.maps.importLibrary("places");
    this.autocompleteSuggestion = AutocompleteSuggestion;
    this.autocompleteSessionToken = new AutocompleteSessionToken();
  }

  async handlePlaceSelection(item) {
    const place = await item.placePrediction.toPlace();

    await place.fetchFields({
      fields: ['formattedAddress', 'addressComponents', 'id'],
    });

    const formattedAddress = this.getFormattedAddress(place);
    this.searchAddress = formattedAddress;

    $(this.addressInputTarget).val(formattedAddress);
    $(this.addressGeocodeServiceIdInputTarget).val(place.id);
    $(this.addressCountryInputTarget).val(this.getCountryISO3(place));

    try {

      const addressData = await this.lookupGeocodedAddress(place);
      if(addressData){
        this.updateAddressFields(addressData);
      }

    } catch (error) {
      console.log("Address Lookup Error", error)
    }
  }

  getFormattedAddress(place) {
    let address = place.formattedAddress;
    // const country = place.addressComponents.find(component =>
    //   component.types.includes("country")
    // );

    // const countryISO3 = getCountryISO3(country.shortText);

    // // This is a hack to get the address to work with the geocoder.
    // // The geocoder expects the address to be in the format of "123 Main St, City, State, Country"
    // // But the address returned from the Google Places API is not in this format.
    // if(!address.includes(countryISO3)){
    //   address = address + ", " + countryISO3;
    // }

    return address;
  }

  getCountryISO3(place){
    const country = place.addressComponents.find(component =>
      component.types.includes("country")
    );
    return getCountryISO3(country.shortText);
  }

  async lookupGeocodedAddress(place) {
    const baseUrl = window.location.origin;
    const path = this.data.get("findGeocodedAddressUrlValue");
    const url = new URL(path, baseUrl);
    const placeId = place.id;
    let address = this.getFormattedAddress(place);

    if(!address.includes(this.addressCountryInputTarget.value)){
      address += ", " + this.addressCountryInputTarget.value;
    }

    // Append the address and placeId to the URL
    // The search will try to use the placeId to find the address
    // If it doesn't find it, it will use the address
    url.searchParams.append('geocoded_address', address);
    url.searchParams.append('geocode_service_id', placeId);

    const response = await fetch(url.toString(), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      }
    });

    if (!response.ok) {
      return false;
    }

    return await response.json();
  }

  updateAddressFields(data) {
    if (data.address?.id) {
      console.log("Updating Address ID", data.address.id);
      $(this.addressIdInputTarget).val(data.address.id);
      $(this.addressStatusInputTarget).val(data.address.service_status);
    } else {
      this.clearAddressFields();
    }
  }

  clearAddressFields() {
    console.log("Clearing Address Fields");
    $(this.addressIdInputTarget).val('');
    $(this.addressStatusInputTarget).val('');
  }

  getGoogleAutocompleteConfig(){
    return {
      resolver: 'custom',
      preventEnter: true,
      events: {
        search: async function (query, callback) {
          try {
            const request = {
              input: query,
              sessionToken: this.autocompleteSessionToken,
              language: 'en',
              region: 'us',
              includedPrimaryTypes: ['street_address'] // Optional
            };
    
            const { suggestions } =
              await this.autocompleteSuggestion.fetchAutocompleteSuggestions(
                request
              );
    
            const results = suggestions.map((s) => { return {
              text: s.placePrediction.text.toString(), // or s.placePrediction.description
              value: s.placePrediction.placeId,
              placePrediction: s.placePrediction,
              source: 'google'
            }});

            this.autocompleteSuggestions = results;
   
            callback(results);
          } catch (err) {
            console.error('Autocomplete error', err);
            callback([]);
          }
        }.bind(this)
      },
      minLength: 2,
    }
  }

  getIspLinkAutocompleteConfig(){
    return {
      preventEnter: true,
      resolverSettings: {
        url: this.data.get("typeaheadUrlValue"),
        queryKey: 'q',
        requestThrottling: 400,
        fail: function (xhr, status, error) {  
          console.error("AJAX Request Failed:", xhr, status, error);
        }
      },
      events: {
        searchPre: this.searchPre.bind(this),
        searchPost: this.searchPost.bind(this)
      },
      minLength: 2,
      noResultsText: ''
    }
  }

  initializeBootstrapAutocomplete() {

    let config;
    if(this.data.get("useGoogleAutocompleteValue") === "true"){ 
      config = this.getGoogleAutocompleteConfig();
    } else {
      config = this.getIspLinkAutocompleteConfig();
    }

    $(this.addressInputTarget).autoComplete(config);

    $(this.addressInputTarget).on("autocomplete.select", this.select.bind(this));
    $(this.addressInputTarget).on("autocomplete.freevalue", this.freeValue.bind(this));
  }

  async handleSubmitButton(event) {
    event.preventDefault(); // Prevent default submission initially
    const submitButton = event.currentTarget;
    this.setSubmitting(submitButton, true);

    if (!(await this.validateAddress())) {
      this.setSubmitting(submitButton, false);
      return;
    }

    if (!this.hasLeadModalMarkup) {
      this.element.submit()
      return
    }

    const addressStatus = this.addressStatusInputTarget.value || ""
    const full = this.leadCaptureConfig
    const addressId = (this.addressIdInputTarget.value || "").trim()

    if (shouldSkipLeadCaptureModal(this.element, full, addressStatus, this.currentStep, addressId)) {
      $(this.emailInputTarget).prop("required", false)
      try {
        applyStoredLeadCaptureAnswersToForm(this.element)
      } catch (_e) {
        // Cached answers must not stop the address check.
      }
      this.element.submit()
      return
    }

    if (!$("#leadCaptureEmailModal").length) {
      this.element.submit()
      return
    }

    this.setSubmitting(submitButton, false)
    this.showModal()
    $(this.emailInputTarget).prop("required", true)
  }

  setSubmitting(button, isSubmitting) {
    if (!button) return

    if (isSubmitting) {
      if (!button.dataset.originalHtml) {
        button.dataset.originalHtml = button.innerHTML
      }
      const loadingLabel = button.dataset.loadingLabel || button.textContent.trim()
      button.disabled = true
      button.innerHTML = `<span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>${loadingLabel}`
      return
    }

    button.disabled = false
    if (button.dataset.originalHtml) {
      button.innerHTML = button.dataset.originalHtml
    }
  }

  showModal(){
    const addressStatus = this.addressStatusInputTarget.value;
    const addressId = this.addressIdInputTarget.value.trim();

    const $modal = $("#leadCaptureEmailModal")
    if (!$modal.length) return
    if (this.hasLeadModalMarkup && $modal.length) {
      const copy = mergeLeadCaptureCopy(this.leadCaptureConfig, addressStatus)
      applyLeadCaptureCopyToModal($modal, copy, this.leadCaptureConfig, addressStatus)
      prefillLeadCaptureModalFromSession($modal, this.element)
    }

    const dismissable = leadCaptureDismissable(addressId, addressStatus, this.currentStep)

    $(this.modalCancelTarget).toggle(dismissable)

    $modal.modal({
      backdrop: dismissable ? true : 'static',
      keyboard: dismissable
    })
    $modal.modal("show")

  }

  async validateAddress(){

    // Return true if we have an address id
    if($(this.addressIdInputTarget).val() || $(this.addressGeocodeServiceIdInputTarget).val()){
      // Geocoded-only entries are not in ISPLink DB yet; preserve the synthetic
      // status so by_status lead-capture rules (e.g. address_not_found) can match.
      if (!$(this.addressIdInputTarget).val() && !$(this.addressStatusInputTarget).val()) {
        $(this.addressStatusInputTarget).val("address_not_found")
      }
      return true;
    }

    const streetAddress = this.addressInputTarget.value.trim();
    if (!streetAddress) {
      this.displayStreetError("Street address is required.");
      return false;
    }
    const response = await fetch(this.data.get("validationUrlValue"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ street_address: streetAddress })
    });

    if (!response.ok) {
      const data = await response.json(); // Parse JSON response
      const errorMessage = data.error || "Invalid address. Please check and try again.";
      this.displayStreetError(errorMessage);
      return;
    }

    const data = await response.json();
    const resolvedAddress = data.resolved_address;
    if (resolvedAddress?.id) {
      $(this.addressIdInputTarget).val(resolvedAddress.id);
      $(this.addressStatusInputTarget).val(resolvedAddress.service_status || "");
      $(this.addressGeocodeServiceIdInputTarget).val(resolvedAddress.geocode_service_id || "");
    }

    this.clearStreetError();
    // No address_id (or geocode path): server treats as not in DB → address_not_found. Lead
    // capture + by_status needs this set or addressStatus is "" and the email modal is skipped.
    if (!$(this.addressIdInputTarget).val()) {
      $(this.addressStatusInputTarget).val("address_not_found")
    }
    return response.ok;
  }

  displayStreetError(message) {
    this.streetErrorTarget.textContent = message;
    this.streetErrorTarget.classList.remove("d-none");
  }

  clearStreetError() {
    this.streetErrorTarget.textContent = "";
    this.streetErrorTarget.classList.add("d-none");
  }

  submitForm() {
    const email = this.emailInputTarget.value.trim();
    if (!this.validateEmail(email)) {
      $(this.emailErrorTarget).removeClass("d-none");
      return;
    }
    $(this.emailErrorTarget).addClass("d-none");

    const $modal = $("#leadCaptureEmailModal")
    const addressStatus = this.addressStatusInputTarget.value || ""
    const howHeard = validateAndCollectHowHeard($modal, this.leadCaptureConfig, addressStatus)
    if (!howHeard.valid) return

    $modal.modal("hide");

    saveLeadCaptureAnswers({
      email,
      how_heard: howHeard.how_heard,
      how_heard_other: howHeard.how_heard_other,
      signup_id: this.element.dataset.leadCaptureSignupId || ""
    })

    // Submit the form (status_form fields for how_heard / how_heard_other are
    // already form-bound via _lead_capture_email_modal partial).
    this.element.submit();
  }

  validateEmail(email) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }

  select(_, item) {
    this.searchAddress = item.text;
    if(item.source == 'google'){
      this.handlePlaceSelection(item);
    } else {
      if (item.multi_unit) {
        $(this.addressGeocodeServiceIdInputTarget).val(item.geocode_service_id);
        $(this.addressInputTarget).autoComplete('set', item.text);
        $(this.addressInputTarget).autoComplete('show');
        $(this.addressInputTarget).autoComplete('clear');
      } else {
        console.log("Setting Address ID", item.id);
        $(this.addressIdInputTarget).val(item.id);
        $(this.addressStatusInputTarget).val(item.service_status);

      }
    }
  }

  freeValue(){
    if(this.searchAddress.trim() != $(this.addressInputTarget).val().trim()){
      $(this.addressIdInputTarget).val('');
      $(this.addressStatusInputTarget).val('');
      this.searchAddress = $(this.addressInputTarget).val();
    }
  }

  searchPre(newValue) {
    this.clearStreetError();
    return newValue;
  }

  searchPost(resultsFromServer) {
    return resultsFromServer;
  }

}
